export default __webpack_public_path__ + "static/media/ndah_cer.26b75e0d.jpeg";